import { render, staticRenderFns } from "./Waveforms.vue?vue&type=template&id=1950bd97&scoped=true&"
import script from "./Waveforms.vue?vue&type=script&lang=js&"
export * from "./Waveforms.vue?vue&type=script&lang=js&"
import style0 from "./Waveforms.vue?vue&type=style&index=0&id=1950bd97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950bd97",
  null
  
)

export default component.exports